export default function isLinkActive(link) {
    if (!link) {
        return false;
    }
    if (link.active) {
        return true;
    }
    if (link.links) {
        let activeSublink = link.links.find(sublink => isLinkActive(sublink));
        if (activeSublink) {
            return true;
        }
    }
    return false;
}
